import { render, staticRenderFns } from "./ComponentLocation.vue?vue&type=template&id=54aac95a"
import script from "./ComponentLocation.vue?vue&type=script&lang=js"
export * from "./ComponentLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports